var gridcell_popmenu = function(el){
	var uid = $(el).data('uid');

	var popmenu = {
		uid:uid,
		current:null,
		setMenu:function(mode)
		{
			popmenu.current=mode;
			$(el).find('li').removeClass('active');
			$(el).find('li[data-mode="'+mode+'"]').addClass('active');
		},
		picture: {
			available:$(el).find('li[data-mode="picture"]').length ? 1:0,
			getContainer:function() {
				// pas de container à manipuer
				return $('#nothing-to-select-here');
			},
			show:function(){
				if(popmenu.current=='picture')
					return;
				//console.log('popmenu.picture.show')
				popmenu.setMenu('picture');
				setTimeout(function(){
					popmenu.video.hide();
					popmenu.cinemagraph.hide();
					popmenu.map.hide();
				},100);
			},
			hide:function(){
				//console.log('popmenu.picture.hide')
				// nothing to do
			}
		},
		cinemagraph:{
			available:$(el).find('li[data-mode="cinemagraph"]').length ? 1:0,
			getContainer:function() {
				var li = $(el).find('li[data-mode="cinemagraph"]');
				var selector = li ? li.data('selector') : null;
				return $(selector || '#'+popmenu.uid+'-background-cinemagraph')
			},
			show : function(){
				if(popmenu.current=='cinemagraph')
					return;
				//console.log('popmenu.cinemagraph.show')
				popmenu.setMenu('cinemagraph');

				var container = popmenu.cinemagraph.getContainer();
				container.show();
				container.removeClass('hidden')
				window.hapi_background_video.play(container, 0);

				setTimeout(function(){
					popmenu.video.hide();
					popmenu.map.hide();
				},100)
			},
			hide : function(){
				var container = popmenu.cinemagraph.getContainer();
				window.hapi_background_video.stop(container);
				container.hide()
				container.addClass('hidden')
			}
		},
		video: {
			available:$(el).find('li[data-mode="video"]').length ? 1:0,
			getContainer:function() {
				var li = $(el).find('li[data-mode="video"]');
				var selector = li ? li.data('selector') : null;
				return $(selector || '#'+popmenu.uid+'-background-video')
			},
			show : function(){
				if(popmenu.current=='video')
					return;
				//console.log('popmenu.video.show')
				popmenu.setMenu('video');

				var container = popmenu.video.getContainer();
				container.show()
				container.removeClass('hidden')

				var hapiVideoPlayer = container.find('hapi-video')
				if(hapiVideoPlayer.length>0)
					hapiVideoPlayer[0].play();
				else
					window.hapi_background_video.play(container, popmenu.picture.available ? 1:0);

				if(popmenu.picture.available || popmenu.cinemagraph.available)
					container.css({'z-index':100});

				setTimeout(function(){
					popmenu.cinemagraph.hide();
					popmenu.map.hide();
				},100);
			},
			hide : function(){
				var container = popmenu.video.getContainer();

				var hapiVideoPlayer = container.find('hapi-video')
				if(hapiVideoPlayer.length>0)
					hapiVideoPlayer[0].pause();
				else
					window.hapi_background_video.stop(container);

				container.hide()
				container.addClass('hidden')
			}
		},
		map: {
			available:$(el).find('li[data-mode="map"]').length ? 1:0,
			getContainer:function() {
				var li = $(el).find('li[data-mode="map"]');
				var selector = li ? li.data('selector') : null;
				return $(selector || '#'+popmenu.uid+'-background-map')
			},
			show : function(){
				if(popmenu.current=='map')
					return;
				//console.log('popmenu.map.show')
				popmenu.setMenu('map');

				var container = popmenu.map.getContainer();
				if(!container.data('gmapLoaded')) // initialisation unique de la carte
				{
					container.data('gmapLoaded',true);
					// on utilise le comportement de chargement automatique pour démarrer l'apparition
					container.addClass('gmap-onload');
				}
				container.show()
				container.removeClass('hidden')
				if(popmenu.picture.available || popmenu.video.available || popmenu.cinemagraph.available)
					container.css({'z-index':100});

				setTimeout(function(){
					popmenu.video.hide();
					popmenu.cinemagraph.hide();
					if(HapimapLoader)
					{
						HapimapLoader.resetAll();
					}
				},100);
			},
			hide : function(){
				//console.log('popmenu.map.hide')
				var container = popmenu.map.getContainer();
				container.hide();
				container.addClass('hidden')
			}
		}
	};
	$(el).data('popmenu',popmenu);

	$(el).find("li").on('click',function(){
		var mode = $(this).data('mode');
		var popmenu = $(this).parents('.gridcell_popmenu').eq(0).data('popmenu');
		//console.log(this,mode,popmenu);
		if(popmenu[mode])
		{
			popmenu[mode].show();
		}
	})

	$(el).find("li").eq(0).trigger('click');
}

$(document).ready(function() {
	$('.gridcell_popmenu').each(function(){
		gridcell_popmenu(this);
	});
});